import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren, EventEmitter,
  Input,
  Output,
  QueryList,
  TemplateRef
} from "@angular/core";
import {IntTabsActionDirective} from "./int-tabs-action.directive";
import {IntTabsContentDirective} from "./int-tabs-content.directive";

@Component({
  selector: 'int-tabs',
  template: `
    <div class="tb-container">
      <div class="tb-header">
        <div class="tb-tabs">
          <ng-container *ngFor="let tab of tabsList">
            <button class="tb-tab" (click)="onSelect(tab.intTabsAction)" [class.is-active]="tab.intTabsAction === this.activeTab">
              <ng-container *ngTemplateOutlet="tab.templateRef"></ng-container>
            </button>
          </ng-container>
        </div>
      </div>
      <div class="tb-container__content">
        <ng-container *ngTemplateOutlet="getContentTemplateByKey(activeTab)"></ng-container>
      </div>
    </div>
  `,
  styleUrls: ['./int-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntTabsComponent {

  @Input() activeTab: string | number | null = null;
  @Output() onHandleChange = new EventEmitter<string | number | null>();

  @ContentChildren(IntTabsActionDirective) readonly tabsList!: QueryList<IntTabsActionDirective>;
  @ContentChildren(IntTabsContentDirective) readonly contentList!: QueryList<IntTabsContentDirective>;

  getContentTemplateByKey(key: string | number | null): TemplateRef<any> | null {
    return this.contentList.find((content) => {
      return content.intTabsContent === key;
    })?.templateRef || null;
  }

  onSelect(tab: string | number | null) {
    this.activeTab = tab;
    this.onHandleChange.next(tab);
  }
}
